// extracted by mini-css-extract-plugin
export default {"validatePage":"ValidateCertificate_validatePage__5WD+I","validateFormLayout":"ValidateCertificate_validateFormLayout__kxEYG"};